export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f4d5152aecc19eb87fa1bf8c4e05c689f03ee3710&name=fetchTypeahead!'